/*=============================================
OwlCarouselConfig
=============================================*/

export let OwlCarouselConfig = {
  fnc: function () {
    var target = $(".owl-slider");
    if (target.length > 0) {
      target.each(function () {
        var el = $(this),
          dataAuto = el.data("owl-auto"),
          dataLoop = el.data("owl-loop"),
          dataSpeed = el.data("owl-speed"),
          dataGap = el.data("owl-gap"),
          dataNav = el.data("owl-nav"),
          dataDots = el.data("owl-dots"),
          dataAnimateIn = el.data("owl-animate-in")
            ? el.data("owl-animate-in")
            : "",
          dataAnimateOut = el.data("owl-animate-out")
            ? el.data("owl-animate-out")
            : "",
          dataDefaultItem = el.data("owl-item"),
          dataItemXS = el.data("owl-item-xs"),
          dataItemSM = el.data("owl-item-sm"),
          dataItemMD = el.data("owl-item-md"),
          dataItemLG = el.data("owl-item-lg"),
          dataItemXL = el.data("owl-item-xl"),
          dataNavLeft = el.data("owl-nav-left")
            ? el.data("owl-nav-left")
            : "<i class='icon-chevron-left'></i>",
          dataNavRight = el.data("owl-nav-right")
            ? el.data("owl-nav-right")
            : "<i class='icon-chevron-right'></i>",
          duration = el.data("owl-duration"),
          datamouseDrag = el.data("owl-mousedrag") == "on" ? true : false;
        if (
          target.children("div, span, a, img, h1, h2, h3, h4, h5, h5").length >=
          2
        ) {
          el.owlCarousel({
            animateIn: dataAnimateIn,
            animateOut: dataAnimateOut,
            margin: dataGap,
            autoplay: dataAuto,
            autoplayTimeout: dataSpeed,
            autoplayHoverPause: true,
            loop: dataLoop,
            nav: dataNav,
            mouseDrag: datamouseDrag,
            touchDrag: true,
            autoplaySpeed: duration,
            navSpeed: duration,
            dotsSpeed: duration,
            dragEndSpeed: duration,
            navText: [dataNavLeft, dataNavRight],
            dots: dataDots,
            items: dataDefaultItem,
            responsive: {
              0: {
                items: dataItemXS,
              },
              480: {
                items: dataItemSM,
              },
              768: {
                items: dataItemMD,
              },
              992: {
                items: dataItemLG,
              },
              1200: {
                items: dataItemXL,
              },
              1680: {
                items: dataDefaultItem,
              },
            },
          });
        }
      });
    }
  },
};

/*=============================================
CarouselNavigation
=============================================*/

export let CarouselNavigation = {
  fnc: function () {
    var prevBtn = $(".ps-carousel__prev"),
      nextBtn = $(".ps-carousel__next");
    prevBtn.on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("href");
      $(target).trigger("prev.owl.carousel", [1000]);
    });
    nextBtn.on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("href");
      $(target).trigger("next.owl.carousel", [1000]);
    });
  },
};

/*=============================================
SlickConfig
=============================================*/

export let SlickConfig = {
  fnc: function () {
    var product = $(".ps-product--detail");
    if (product.length > 0) {
      var primary = product.find(".ps-product__gallery"),
        second = product.find(".ps-product__variants"),
        vertical = product.find(".ps-product__thumbnail").data("vertical");
      primary.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".ps-product__variants",
        fade: true,
        dots: false,
        infinite: false,
        arrows: primary.data("arrow"),
        prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
        nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>",
      });
      second.slick({
        slidesToShow: second.data("item"),
        slidesToScroll: 1,
        infinite: false,
        arrows: second.data("arrow"),
        focusOnSelect: true,
        prevArrow: "<a href='#'><i class='fa fa-angle-up'></i></a>",
        nextArrow: "<a href='#'><i class='fa fa-angle-down'></i></a>",
        asNavFor: ".ps-product__gallery",
        vertical: vertical,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              arrows: second.data("arrow"),
              slidesToShow: 4,
              vertical: false,
              prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
              nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>",
            },
          },
          {
            breakpoint: 992,
            settings: {
              arrows: second.data("arrow"),
              slidesToShow: 4,
              vertical: false,
              prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
              nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>",
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              vertical: false,
              prevArrow: "<a href='#'><i class='fa fa-angle-left'></i></a>",
              nextArrow: "<a href='#'><i class='fa fa-angle-right'></i></a>",
            },
          },
        ],
      });
    }
  },
};

/*=============================================
ProductLightbox
=============================================*/

export let ProductLightbox = {
  fnc: function () {
    var product = $(".ps-product--detail");
    if (product.length > 0) {
      $(".ps-product__gallery").lightGallery({
        selector: ".item a",
        thumbnail: true,
        share: false,
        fullScreen: false,
        autoplay: false,
        autoplayControls: false,
        actualSize: false,
      });
      if (product.hasClass("ps-product--sticky")) {
        $(".ps-product__thumbnail").lightGallery({
          selector: ".item a",
          thumbnail: true,
          share: false,
          fullScreen: false,
          autoplay: false,
          autoplayControls: false,
          actualSize: false,
        });
      }
    }
    $(".ps-gallery--image").lightGallery({
      selector: ".ps-gallery__item",
      thumbnail: true,
      share: false,
      fullScreen: false,
      autoplay: false,
      autoplayControls: false,
      actualSize: false,
    });
    $(".ps-video").lightGallery({
      thumbnail: false,
      share: false,
      fullScreen: false,
      autoplay: false,
      autoplayControls: false,
      actualSize: false,
    });
  },
};

/*=============================================
CountDown
=============================================*/

export let CountDown = {
  fnc: function () {
    var time = $(".ps-countdown");
    time.each(function () {
      var el = $(this),
        value = $(this).data("time");
      var countDownDate = new Date(value).getTime();
      var timeout = setInterval(function () {
        var now = new Date().getTime(),
          distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          ),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);
        el.find(".days").html(days);
        el.find(".hours").html(hours);
        el.find(".minutes").html(minutes);
        el.find(".seconds").html(seconds);
        if (distance < 0) {
          clearInterval(timeout);
          el.closest(".ps-section").hide();
        }
      }, 1000);
    });
  },
};

/*=============================================
Rating
=============================================*/

export let Rating = {
  fnc: function () {
    $("select.ps-rating").each(function () {
      var readOnly;
      if ($(this).attr("data-read-only") == "true") {
        readOnly = true;
      } else {
        readOnly = false;
      }
      $(this).barrating({
        theme: "fontawesome-stars",
        readonly: readOnly,
        emptyValue: "0",
      });
    });
  },
};

/*=============================================
ProgressBar
=============================================*/

export let ProgressBar = {
  fnc: function () {
    var progress = $(".ps-progress");
    progress.each(function (e) {
      var value = $(this).data("value");
      $(this)
        .find("span")
        .css({
          width: value + "%",
        });
    });
  },
};
